import { isbot } from 'isbot';
import { isBrowser } from '../env';
/**
 * Detects a known bot/crawler by user-agent, per Datadog's guidance for
 * filtering bot sessions at intake:
 * https://docs.datadoghq.com/real_user_monitoring/guide/identify-bots-in-the-ui/#filter-out-bot-sessions-on-intake
 *
 * `isbot` matches against the same crawler-user-agents list Datadog's guide
 * references, and is already a dependency of the SSR apps this package
 * serves.
 */
export function isBotSession() {
    return isBrowser() && isbot(navigator.userAgent);
}
